import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher, MatDialogRef, MatMenuTrigger } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { PolicyService } from 'src/app/services/policy.service';
import * as _ from 'lodash';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { UtilityService } from 'src/app/services/utility.service';
import { MapsService } from 'src/app/services/maps.service';
import { frequencyDays } from 'src/app/_models/staticArray';



export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-edit-client-modal',
  templateUrl: './edit-client-modal.component.html',
  styleUrls: ['./edit-client-modal.component.scss']
})
export class EditClientModalComponent implements OnInit {

  editClientForm: FormGroup
  data
  error
  isLoading: boolean = false
  loading: boolean = false
  passwords = ''
  confirmPassword = ''
  show: boolean
  pwd: boolean
  show1: boolean
  pwd1: boolean
  passwordNotMatch: boolean = false
  clientDetails
  latitude: any
  longitude: any
  address: string
  isMapEdit: boolean = true
  selectedIndex: number = 0
  selectedLocation: Object
  displayAddress
  locationList: Array<[]>
  noLocation = {
    title: "No Locations!",
    data: "You have not yet added any location"
  }
  isLocation: boolean = false
  rgba: any;
  always: any;
  matcher = new MyErrorStateMatcher();
  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  color
  _isControlDisable = true
  projectCodeList = []
  _isProjectCodeExist = false
  projectcodeIndex
  frequencyDays = frequencyDays


  constructor(
    public _clientService: ClientService,
    public formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public route: Router,
    public _encryptDecryptService: EncryptDecryptService,
    public _policyService: PolicyService,
    public _utilityService: UtilityService,
    public _mapsService: MapsService,
    public dialogRef: MatDialogRef<any>,
    public _cd: ChangeDetectorRef
  ) {
    this.activatedRoute.params.subscribe(params => {
      console.log(params['id']);
      this.isLoading = true
      this._clientService.getClient(params['id']).subscribe(data => {
        console.log("RECEIVED = ", data)
        if (data && data.length) {
          this.createForm(data[0])
          this.locationList = data[0].locations
          this.projectCodeList = data[0].projectcodeList
          // setTimeout(() => {
          //   // this.selectedLocation
          //   this.setLocations(data[0].locations[0])
          // }, 1000)
          this.clientDetails = data[0]
          if (this.clientDetails.locations && !this.clientDetails.locations.length) this.isMapEdit = false
          else this.isMapEdit = true
          this.color = this.clientDetails && this.clientDetails.color ? this.clientDetails.color : '#212529'
          console.log("After client details", this.clientDetails);
          this.latitude = this.clientDetails && this.clientDetails.physicalAddress ? this.clientDetails.physicalAddress.coords.lat : ''
          this.longitude = this.clientDetails && this.clientDetails.physicalAddress ? this.clientDetails.physicalAddress.coords.lng : ''
          this.address = this.clientDetails && this.clientDetails.physicalAddress ? this.clientDetails.physicalAddress.address : ''
          // this.isMapEdit = this.clientDetails && this.clientDetails.physicalAddress ? true : false
        } else this.createForm()
        this.isLoading = false
      });
    })
  }

  ngOnInit() {
    // this.isLoading = true
    this.createForm()

    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#capassword").click(function () {
      $("#capassword").toggleClass("fa-eye fa-eye-slash");
    });
  }
  keyDown(event) {
    var keyCode = event.keyCode;
    return !(keyCode == 69 || keyCode == 101)
  }
  // CREATE FORM

  createForm(editData?) {
    console.log("data while edit", editData);
    this.editClientForm = this.formBuilder.group({
      name: new FormControl(editData && editData.name ? editData.name : '', Validators.required),
      email: new FormControl(editData && editData.email ? editData.email : '', Validators.email),
      password: new FormControl(editData && editData.password ? this._encryptDecryptService.decrypt(editData.password) : '', Validators.compose([
        Validators.required, Validators.minLength(8),
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      ])),
      confirmPassword: new FormControl(editData && editData.password ? this._encryptDecryptService.decrypt(editData.password) : '', Validators.required),
      contactNumber: new FormControl(editData && editData.contactNumber ? editData.contactNumber : ''),
      paymentTerms: new FormControl(editData && editData.paymentTerms ? editData.paymentTerms : ''),
      accountEmail: new FormControl(editData && editData.accountEmail ? editData.accountEmail : '', Validators.email),
      accountName: new FormControl(editData && editData.accountName ? editData.accountName : ''),
      accountNumber: new FormControl(editData && editData.accountNumber ? editData.accountNumber : ''),
      color: new FormControl(editData && editData.color ? editData.color : ''),
      locationsList: this.formBuilder.array(this.multipleLocation(editData && editData.locations && editData.locations.length ? editData.locations : [])),
      projectCodes: this.formBuilder.array(this.multipleProjectCode((editData && editData.projectCodes) ? editData.projectCodes : [])),
      weekStartDay: new FormControl((editData && editData.weekStartDay) ? editData.weekStartDay : '')
      // address: new FormControl(editData && editData.physicalAddress ? editData.physicalAddress.address : '')
    }, {
      validator: this._policyService.passwordMatchValidator
    })
    this.changeFormvalue()
    let codeList = this.editClientForm.controls.projectCodes.value
    if (codeList && codeList.length) {
      this.disableProjectCode(codeList)
    }
  }

  // change form value
  changeFormvalue() {
    this.editClientForm.valueChanges.subscribe(value => {
      if (value.projectCodes && value.projectCodes.length) {
        this.disableProjectCode(value.projectCodes)
      }
    })
  }



  // GET PROJECTCODE LIST
  get getProjectcodeList() { return this.editClientForm.get('projectCodes') as FormArray; }

  // MULTIPLE projectcode LIST 
  multipleProjectCode(list) {
    console.log("WHAT IS THE LIST", list)
    if (list && list.length) {
      let listdata = []
      list.forEach(async (item) => {
        await listdata.push(new FormGroup({
          projectcode: new FormControl((item && item.projectcode) ? item.projectcode : ''),
        }))
      })
      return listdata;
    } else {
      return [this.formBuilder.group({
        projectcode: new FormControl('')
      })]
    }
  }

  // ADD projectcode
  addMultipleProjectcode() {
    const control = <FormArray>this.editClientForm.controls.projectCodes
    control.push(this.formBuilder.group({
      projectcode: new FormControl('')
    }))
  }

  // REMOVE projectcode
  removeProjectcode(index) {
    const control = <FormArray>this.editClientForm.controls.projectCodes
    control.removeAt(index)
  }

  // DISABLE projectcode
  disableProjectCode(projectcodes) {
    let lastPOnumber = projectcodes[projectcodes.length - 1]
    if (lastPOnumber.projectcode !== '') this._isControlDisable = false
    else this._isControlDisable = true
  }

  // projectcode CHANGE EVENT
  projectcodeChangeEvent(event, index) {
    const tempVal = event.target.value
    const checkValue = this.projectCodeList.filter((item) => {  // check the value is exist or not
      return item.projectcode === tempVal
    })
    if (checkValue && checkValue.length) {
      this._isProjectCodeExist = true
      this.projectcodeIndex = index
      this._isControlDisable = true
    }
    else {
      this._isProjectCodeExist = false;
      // this._isControlDisable = false
      let codeList = this.editClientForm.controls.projectCodes.value
      if (codeList && codeList.length) {
        this.disableProjectCode(codeList)
      }
    }
    console.log("CHECK VALUE", checkValue, this._isControlDisable)
  }

  get locationDetails() { return <FormArray>this.editClientForm.get('locationsList'); }

  multipleLocation(locations) {
    console.log("Location data", locations);
    if (locations && locations.length) {
      let locationArray = []
      _.forEach(locations, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl((singleLocation && singleLocation.title) ? singleLocation.title : singleLocation.title),
          coordinates: new FormControl((singleLocation && singleLocation.locationGeometry) ? singleLocation.locationGeometry.coordinates : []),
          address: this.formBuilder.array(this.addresList(singleLocation.address && singleLocation.address.length ? singleLocation.address : [])),
          _id: new FormControl(singleLocation._id),
          locationType: new FormControl((singleLocation && singleLocation.locationType) ? singleLocation.locationType : 'client'),
          client: new FormControl(singleLocation.client)
        }))
      })
      return locationArray;
    } else {
      return [this.formBuilder.group({
        title: new FormControl(''),
        coordinates: new FormControl([]),
        address: this.formBuilder.array(this.addresList([])),
        locationType: new FormControl('client'),
      })]
    }

  }


  addresList(address) {
    if (address && address.length) {
      let locationArray = []
      _.forEach(address, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl((singleLocation && singleLocation.title) ? singleLocation.title : singleLocation.title),
        }))
      })
      return locationArray;
    } else {
      return [this.formBuilder.group({
        title: new FormControl('')
      })]
    }
  }


  // UTILITY FUNCITONS

  onKeyPress(x) {
    x.preventDefault();
    this.clickMenuTrigger.openMenu();
    console.log("value of password", this.passwords);
  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }

  closeModel() {
    this.clickMenuTrigger.closeMenu();
  }

  onKeyUp(x) {
    this.confirmPassword = x.target.value;
    if (this.editClientForm && this.editClientForm.value && this.editClientForm.value.password != this.confirmPassword) {
      this.passwordNotMatch = true
      this.editClientForm.get('confirmPassword').markAsTouched();
    } else if (this.editClientForm.value.password == this.confirmPassword) {
      this.passwordNotMatch = false
    }
  }

  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue, this.selectedIndex)
    // if (this.clientDetails.locations && this.clientDetails.locations.length) {
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
    let splitAddress = this.address.split(',')
    this.displayAddress = splitAddress.map((x) => { return { title: x } })
    this.locationDetails.at(this.selectedIndex).patchValue({
      coordinates: [this.longitude, this.latitude],
      title: this.address,
      // address: []
    })
    // this.locationDetails.at(this.selectedIndex)
    this.getAddressList(this.selectedIndex).clear()
    this.updateAddressData(splitAddress)
    // if(this.locationList && !this.locationList)
    console.log("this.editClientForm.controls.value", this.editClientForm.value);
    // }
  }


  updateAddressData(address) {
    console.log("WHat is the address array", address);
    const control = this.getAddressList(this.selectedIndex)
    console.log("This is the control value", control);
    // control.at(0).patchValue({ title: address[0] })
    address.shift()
    console.log("After remove", address);

    address.forEach(element => {
      console.log("This is the single element", element);
      control.push(
        this.formBuilder.group({
          title: element
        })
      )
    });
    console.log("After push in array", this.editClientForm.value);
    this._cd.detectChanges()
  }

  setLocations(location, elementIndex) {
    console.log("What is the location details", location);
    this.selectedLocation = location
    if (location.coordinates && !location.coordinates.length) {
      this._mapsService.getLocation(location.title).subscribe((locationData) => {
        console.log("This is the location details using address", locationData.lat(), locationData.lng());
        if (locationData == null) return locationData
        this.latitude = locationData.lat()
        this.longitude = locationData.lng()
        this.locationDetails.at(elementIndex).patchValue({
          coordinates: [this.longitude, this.latitude],
        })
      })
    } else {
      this.latitude = location.coordinates[1]
      this.longitude = location.coordinates[0]
      this._cd.detectChanges()
    }
  }

  setStep(index, location) {
    console.log("Here the accordian index", index);
    this.selectedIndex = index
    this.isLocation = false
    let element = (this.editClientForm.get('locationsList') as FormArray).at(index).value;
    console.log("THis is the element of form array", element);
    this.setLocations(element, index)
    // this.isMapEdit = false
  }

  changeLocation(location, inputIndex) {
    let element = []
    element.push(this.locationDetails.at(this.selectedIndex).get('address').value.map((x) => { return x.title }))
    console.log("THis is the element details", element);
    // element[inputIndex] = location
    this.locationDetails.at(this.selectedIndex).patchValue({
      title: element.toString()
    })
  }


  getAddressList(index) {
    return this.locationDetails.at(index).get('address') as FormArray;
  }

  addLocation() {
    console.log("Here the current selected index", this.selectedIndex, this.locationDetails.length);
    this.selectedIndex = this.selectedIndex + ((this.locationDetails.length - 1) + 1)
    this.isLocation = true
    const control = this.locationDetails
    control.push(this.formBuilder.group({
      title: new FormControl(''),
      coordinates: new FormControl([]),
      address: this.formBuilder.array(this.addresList([])),
      locationType: new FormControl('client')
    }))
    this._cd.detectChanges()
  }

  deleteLocation(location, index) {
    console.log("When location is deleted", location, index);
    const control = this.locationDetails
    if (location && location._id) {
      console.log("Call this or not");
      let obj = {
        _id: location._id,
        locationType: 'client'
      }
      this._clientService.deleteLocation(JSON.stringify(obj)).subscribe((deleted) => {
        console.log("Location is removed", deleted);
        control.removeAt(index)
        this._utilityService.handleSnackBar({ msg: "Location removed successfully!", button: "Ok" });
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    } else control.removeAt(index)
  }


  filterProjectcode(codes) {
    codes = codes.filter((x) => { return x.projectCode != "" })
  }

  // API CALL

  onSubmit() {
    console.log("value of form ======> ", this.editClientForm.value)
    this.loading = true
    let finalObj = {
      _id: this.clientDetails._id,
      name: this.editClientForm.value.name,
      email: this.editClientForm.value.email,
      password: this._encryptDecryptService.encrypt(this.editClientForm.value.password),
      confirmPassword: this._encryptDecryptService.encrypt(this.editClientForm.value.confirmPassword),
      contactNumber: this.editClientForm.value.contactNumber,
      paymentTerms: this.editClientForm.value.paymentTerms,
      accountName: this.editClientForm.value.accountName,
      accountEmail: this.editClientForm.value.accountEmail,
      accountNumber: this.editClientForm.value.accountNumber,
      color: this.editClientForm.value.color,
      isPolicy: this.clientDetails.userId.passwordPolicy,
      weekStartDay: this.editClientForm.value.weekStartDay,
      physicalAddress: {
        coords: { lat: this.latitude, lng: this.longitude },
        address: this.address
      },
      projectCodes: this.editClientForm.value.projectCodes.filter((x) => { return x.projectcode != '' }),
    }
    console.log("data to be send to server ", finalObj)
    this._clientService.editClient(finalObj).subscribe(client => {
      this.loading = false;
      console.log("res get after edited client details ", client)
      if (client && client._id) this._utilityService.handleSnackBar({ msg: "Client edited successfully!", button: "Ok" })
      this.route.navigate(['client/list'])
    }, err => {
      this.error = err.msg
      this.loading = false;
    });
  }

  delete() {
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "client")
      .afterClosed().subscribe((confirm) => {
        if (confirm == '') return
        else if (confirm == 'yes') {
          if (confirm == '') return
          else if (confirm == 'yes') {
            this.loading = true;
            this._clientService.deleteClient(this.clientDetails._id, true).subscribe(clients => {
              this.loading = false;
              console.log("res get after deleted client ", clients)
              if (clients) this._utilityService.handleSnackBar({ msg: "Client deleted successfully!", button: "Ok" }), this.route.navigate(['/client/list']);
            }, err => {
              if (err.msg == "Client Not Deleted") this.error = "Client with jobs cannot be deleted"
              this.loading = false;
            });
          }
        }
      })
  }

  /**
   * update location details with new coordinates 
   */
  updateLocationDetails() {
    let finalData = this.locationDetails.at(this.selectedIndex).value
    console.log("This is the final data", finalData);
    if (finalData && finalData._id) {
      this._clientService.updateLocation(finalData).subscribe((locationUpdated) => {
        console.log("Here the location is updatesd", locationUpdated);
        this._utilityService.handleSnackBar({ msg: "Location updated successfully!", button: "Ok" });
      }, err => {
        console.log("Error while update location", err);
        this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    } else {
      finalData['client'] = this.clientDetails._id
      this._clientService.addLocation(finalData).subscribe((locationAdd) => {
        console.log("New location added", locationAdd);
        this._utilityService.handleSnackBar({ msg: "Location added successfully!", button: "Ok" });
      }, err => {
        console.log("Error while location add", err);
        this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    }
  }

}

